
export interface DepartmentSEOData {
  code: string;
  name: string;
  region: string;
  mainCities: string[];
  description: string;
  heroTitle: string;
  heroSubtitle: string;
  specificServices: string[];
  localTestimonial?: {
    text: string;
    author: string;
    city: string;
  };
  seoKeywords: string[];
}

export const departmentSEOData: Record<string, DepartmentSEOData> = {
  "12": {
    code: "12",
    name: "Aveyron",
    region: "Occitanie",
    mainCities: ["Rodez", "Millau", "Villefranche-de-Rouergue", "Decazeville", "Saint-Affrique", "Onet-le-Château"],
    description: "Groupe Fabre Environnement est votre partenaire de confiance pour la location de bennes dans l'Aveyron. Avec notre siège social à Rodez, nous connaissons parfaitement les spécificités de notre territoire aveyronnais. De Millau à Villefranche-de-Rouergue, en passant par Decazeville, nous intervenons rapidement pour tous vos projets de rénovation, construction ou nettoyage. Notre expertise locale nous permet d'adapter nos services aux contraintes géographiques du département, notamment dans les zones rurales et les centres historiques.",
    heroTitle: "Location de bennes Aveyron (12)",
    heroSubtitle: "Votre expert local en gestion des déchets à Rodez, Millau et dans tout l'Aveyron",
    specificServices: [
      "Collecte adaptée aux contraintes du patrimoine historique",
      "Service en zone rurale aveyronnaise",
      "Gestion des déchets de rénovation de bâti ancien",
      "Solutions pour les exploitations agricoles",
      "Intervention dans les gorges du Tarn (Millau)",
      "Service spécialisé pierre de taille et lauze"
    ],
    localTestimonial: {
      text: "Excellent service pour notre chantier de rénovation à Rodez. L'équipe connaît bien les contraintes du centre-ville historique.",
      author: "Pierre M.",
      city: "Rodez"
    },
    seoKeywords: ["location benne Aveyron", "benne Rodez", "location benne Millau", "déchets Aveyron", "benne Villefranche-de-Rouergue"]
  },
  "31": {
    code: "31",
    name: "Haute-Garonne",
    region: "Occitanie", 
    mainCities: ["Toulouse", "Muret", "Saint-Gaudens", "Colomiers", "Tournefeuille", "Blagnac"],
    description: "En Haute-Garonne, Groupe Fabre Environnement répond aux besoins de la métropole toulousaine et de l'ensemble du département. De Toulouse à Saint-Gaudens, nous proposons des solutions de location de bennes adaptées aux contraintes urbaines et périurbaines. Notre connaissance du tissu économique local, de l'industrie aéronautique aux entreprises de services, nous permet d'offrir des services personnalisés pour chaque secteur d'activité.",
    heroTitle: "Location de bennes Haute-Garonne (31)",
    heroSubtitle: "Solutions déchets pour Toulouse et la métropole - Service professionnel en Haute-Garonne",
    specificServices: [
      "Gestion déchets métropole toulousaine",
      "Solutions pour l'industrie aéronautique",
      "Collecte en zone urbaine dense",
      "Service entreprises technologiques",
      "Gestion déchets de bureaux",
      "Solutions chantiers urbains complexes"
    ],
    localTestimonial: {
      text: "Service impeccable pour notre entreprise à Toulouse. Intervention rapide et équipe professionnelle.",
      author: "Marie D.",
      city: "Toulouse"
    },
    seoKeywords: ["location benne Toulouse", "benne Haute-Garonne", "location benne Muret", "déchets Toulouse", "benne métropole toulousaine"]
  },
  "81": {
    code: "81",
    name: "Tarn",
    region: "Occitanie",
    mainCities: ["Albi", "Castres", "Mazamet", "Gaillac", "Lavaur", "Carmaux"],
    description: "Dans le Tarn, Groupe Fabre Environnement met son expertise au service des habitants et entreprises d'Albi à Castres. Notre connaissance des spécificités locales, notamment l'héritage industriel textile et les contraintes du patrimoine UNESCO d'Albi, nous permet de proposer des solutions adaptées. Nous intervenons sur tout le territoire tarnais avec des équipes locales expérimentées.",
    heroTitle: "Location de bennes Tarn (81)",
    heroSubtitle: "Expert en gestion des déchets d'Albi à Castres - Service local dans le Tarn",
    specificServices: [
      "Collecte patrimoine UNESCO Albi",
      "Gestion déchets industrie textile",
      "Solutions viticoles (Gaillac)",
      "Service centres historiques",
      "Collecte déchets industriels spécialisés",
      "Solutions PME locales"
    ],
    localTestimonial: {
      text: "Parfait pour notre chantier à Albi. L'équipe respecte les contraintes du centre historique classé.",
      author: "Jean-Luc R.",
      city: "Albi"
    },
    seoKeywords: ["location benne Tarn", "benne Albi", "location benne Castres", "déchets Tarn", "benne Mazamet"]
  },
  "46": {
    code: "46",
    name: "Lot",
    region: "Occitanie",
    mainCities: ["Cahors", "Figeac", "Gourdon", "Souillac", "Saint-Céré", "Gramat"],
    description: "Dans le Lot, nous adaptons nos services de location de bennes aux spécificités de ce territoire rural préservé. De Cahors à Figeac, notre équipe locale connaît les contraintes d'accès et les réglementations spécifiques aux sites protégés. Nous proposons des solutions respectueuses de l'environnement lotois.",
    heroTitle: "Location de bennes Lot (46)",
    heroSubtitle: "Gestion des déchets respectueuse du territoire lotois - Service de Cahors à Figeac",
    specificServices: [
      "Service sites protégés",
      "Solutions patrimoine rural",
      "Collecte zones touristiques",
      "Gestion déchets viticoles",
      "Service accès difficiles",
      "Solutions écologiques"
    ],
    localTestimonial: {
      text: "Service adapté aux contraintes de notre village classé. Équipe respectueuse et professionnelle.",
      author: "Sophie L.",
      city: "Cahors"
    },
    seoKeywords: ["location benne Lot", "benne Cahors", "location benne Figeac", "déchets Lot", "benne Gourdon"]
  },
  "48": {
    code: "48",
    name: "Lozère",
    region: "Occitanie",
    mainCities: ["Mende", "Marvejols", "Florac", "Saint-Chély-d'Apcher", "Langogne", "La Canourgue"],
    description: "La Lozère, territoire le moins peuplé de France, bénéficie d'un service de proximité adapté à ses spécificités. De Mende à Florac, nous intervenons avec des solutions flexibles pour ce territoire de montagne aux contraintes d'accès particulières. Notre service s'adapte aux besoins des collectivités et des entreprises locales.",
    heroTitle: "Location de bennes Lozère (48)",
    heroSubtitle: "Service de proximité en Lozère - Solutions adaptées de Mende à Florac",
    specificServices: [
      "Service haute montagne",
      "Solutions contraintes d'accès",
      "Collecte hivernale adaptée",
      "Service collectivités rurales",
      "Gestion déchets touristiques",
      "Solutions éco-responsables"
    ],
    localTestimonial: {
      text: "Excellent service malgré notre isolement. L'équipe s'adapte parfaitement aux contraintes montagnardes.",
      author: "André P.",
      city: "Mende"
    },
    seoKeywords: ["location benne Lozère", "benne Mende", "location benne Florac", "déchets Lozère", "benne montagne"]
  },
  "34": {
    code: "34",
    name: "Hérault",
    region: "Occitanie",
    mainCities: ["Montpellier", "Béziers", "Sète", "Agde", "Lunel", "Frontignan"],
    description: "Dans l'Hérault, Groupe Fabre Environnement dessert la métropole de Montpellier et l'ensemble du département jusqu'au littoral méditerranéen. De Montpellier à Béziers, en passant par Sète, nous proposons des solutions adaptées aux zones urbaines denses, aux activités portuaires et aux contraintes saisonnières du tourisme côtier.",
    heroTitle: "Location de bennes Hérault (34)",
    heroSubtitle: "Expert déchets de Montpellier au littoral - Service métropole et côte méditerranéenne",
    specificServices: [
      "Gestion déchets métropole Montpellier",
      "Solutions activités portuaires",
      "Collecte saisonnière littoral",
      "Service zones touristiques",
      "Gestion déchets urbains denses",
      "Solutions événementielles"
    ],
    localTestimonial: {
      text: "Service efficace pour notre restaurant à Sète. Adaptation parfaite aux contraintes du port et du tourisme.",
      author: "Isabelle F.",
      city: "Sète"
    },
    seoKeywords: ["location benne Hérault", "benne Montpellier", "location benne Béziers", "déchets Hérault", "benne Sète"]
  },
  "82": {
    code: "82",
    name: "Tarn-et-Garonne",
    region: "Occitanie",
    mainCities: ["Montauban", "Castelsarrasin", "Moissac", "Caussade", "Valence", "Verdun-sur-Garonne"],
    description: "En Tarn-et-Garonne, nous couvrons de Montauban à Moissac avec des solutions adaptées à ce territoire de transition entre Toulouse et Bordeaux. Notre service répond aux besoins des entreprises agroalimentaires locales, des collectivités et des particuliers, avec une connaissance fine des contraintes logistiques départementales.",
    heroTitle: "Location de bennes Tarn-et-Garonne (82)",
    heroSubtitle: "Solutions déchets de Montauban à Moissac - Service local Tarn-et-Garonne",
    specificServices: [
      "Gestion déchets agroalimentaires",
      "Solutions logistiques adaptées",
      "Service collectivités rurales",
      "Collecte zones industrielles",
      "Gestion déchets agricoles",
      "Solutions PME locales"
    ],
    localTestimonial: {
      text: "Partenaire fiable pour notre exploitation. Service personnalisé et tarifs compétitifs.",
      author: "Michel D.",
      city: "Montauban"
    },
    seoKeywords: ["location benne Tarn-et-Garonne", "benne Montauban", "location benne Moissac", "déchets 82", "benne Castelsarrasin"]
  },
  "95": {
    code: "95",
    name: "Val-d'Oise",
    region: "Île-de-France",
    mainCities: ["Cergy", "Argenteuil", "Sarcelles", "Franconville", "Ermont", "Goussainville"],
    description: "En Val-d'Oise, Groupe Fabre Environnement répond aux besoins de cette zone francilienne dynamique. De Cergy à Argenteuil, nous proposons des solutions adaptées aux contraintes urbaines de la région parisienne. Notre service s'adapte aux besoins des entreprises, collectivités et particuliers du département.",
    heroTitle: "Location de bennes Val-d'Oise (95)",
    heroSubtitle: "Solutions déchets en Île-de-France - Service de Cergy à Argenteuil",
    specificServices: [
      "Service région parisienne",
      "Solutions contraintes urbaines",
      "Collecte zones denses",
      "Gestion déchets tertiaires",
      "Service logistique optimisée",
      "Solutions multi-sites"
    ],
    localTestimonial: {
      text: "Service professionnel adapté aux contraintes franciliennes. Équipe réactive et efficace.",
      author: "Thomas L.",
      city: "Cergy"
    },
    seoKeywords: ["location benne Val-d'Oise", "benne Cergy", "location benne Argenteuil", "déchets Val-d'Oise", "benne Île-de-France"]
  }
};
